import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import type { ApiEnvelope } from 'src/app/core/services/super-admin-auth.service';

interface ReverseGeocodeData {
  address: string | null;
}

@Injectable({ providedIn: 'root' })
export class ReverseGeocodeService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');
  private readonly cache = new Map<string, Observable<string | null>>();

  lookup(lat: number, lng: number): Observable<string | null> {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return of(null);
    }

    const key = `${lat.toFixed(5)},${lng.toFixed(5)}`;
    const cached = this.cache.get(key);
    if (cached) return cached;

    const params = new HttpParams()
      .set('lat', String(lat))
      .set('lng', String(lng));

    const request$ = this.http
      .get<ApiEnvelope<ReverseGeocodeData>>(`${this.base}/admin/sessions/reverse-geocode`, { params })
      .pipe(
        map((env) => env.data?.address ?? null),
        catchError(() => of(null)),
        shareReplay(1),
      );

    this.cache.set(key, request$);
    return request$;
  }
}
